export default "__VITE_ASSET__5ee1147e__"